import { Component, OnInit } from '@angular/core';
import { Koopkrachtpremie } from '../../models/Koopkrachtpremie';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Onderneming } from '../../models/Onderneming';
import { DataService } from '../../services/data.service';
@Component({
  selector: 'app-koopkrachtpremie',
  templateUrl: './koopkrachtpremie.component.html',
  styleUrls: ['./koopkrachtpremie.component.scss'],
})
export class KoopkrachtpremieComponent implements OnInit {
  selectedOption: string = '124 Paritair comité voor het bouwbedrijf';
  koopkrachtpremie: Koopkrachtpremie;
  onderneming: Onderneming;
  form: FormGroup;

  calculate = false;

  basicResult: number = 0;
  advancedResult: number = 0;
  maxAantalWerknemers: number = 0;

  typeKoopkracht = [
    '124 Paritair comité voor het bouwbedrijf',
    '200  Aanvullend Paritair comité voor bedienden',
  ];

  constructor(public dataService: DataService, private fb: FormBuilder) {
    this.form = this.fb.group({
      typeKoopkracht: ['bouwbedrijf', Validators.required],
      winst2019: [0],
      winst2020: [0],
      winst2021: [0],
      winst2022: [0],
      balanstotaal2019: [0],
      balanstotaal2020: [0],
      balanstotaal2021: [0],
      balanstotaal2022: [0],
      aantalWerknemers: [1, Validators.min(1)],
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.onderneming = this.dataService?.getOnderneming();
    console.log(this.onderneming);
  }
 // Add an event handler for the select element's change event
 onTypeKoopkrachtChange() {
  this.calculate = false;
  this.form.patchValue({winst2019: 0,
    winst2020: 0,
    winst2021: 0,
    winst2022: 0,
    balanstotaal2019: 0,
    balanstotaal2020: 0,
    balanstotaal2021: 0,
    balanstotaal2022: 0,
    aantalWerknemers: 1 });

}
  onSubmit() {
    this.basicResult = 0;
    this.advancedResult = 0;
    this.maxAantalWerknemers = 0;
    if (this.form.value.typeKoopkracht == 'bouwbedrijf') {
      let variables =
      [
        this.form.value.winst2019,
        this.form.value.winst2020,
        this.form.value.winst2021,
      ];
      //count the numbers of zero's so we can devide the sum of the total value
      let countNonZeros = variables.filter((value) => value != 0).length;

      // calculate the sum of al the profit
      let sum = variables.reduce((acc, currentValue) => acc + currentValue, 0);

      //calculate the average
      let average = countNonZeros === 0 ? 0 : sum / countNonZeros;

      if(countNonZeros > 0) {
        if (average * 1.15 <= this.form.value.winst2022) {
          this.basicResult = 250;
        }
        if (average * 1.25 <= this.form.value.winst2022) {
          this.basicResult = 500;
        }
        if (average * 1.5 <= this.form.value.winst2022) {
          this.basicResult = 750;
        }

          if(this.basicResult != 0)
          {
            //max 15% gebruiken van de winst van 2022
            let maxWinstPercentage = this.form.value.winst2022 * 0.15;

            //bereken max aantal werkenemers met standaard voorwaarden
            this.maxAantalWerknemers = maxWinstPercentage / this.basicResult;
            
            if( this.form.value.aantalWerknemers > this.maxAantalWerknemers )
            {
              this.advancedResult = (maxWinstPercentage /this.form.value.aantalWerknemers > this.basicResult ? this.basicResult: maxWinstPercentage) / this.form.value.aantalWerknemers;
            }
            else
            {
              this.advancedResult = this.basicResult
            }
          }
      }
    }

    if (this.form.value.typeKoopkracht == 'bedienden') {
      //voorwaarde 1
      let genoegWinst = this.form.value.balanstotaal2022 * 0.05 <= this.form.value.winst2022 ? true:false;

      //voorwaarde 2
      let verhouding2019 :number = this.form.value.winst2019 / this.form.value.balanstotaal2019
      let verhouding2020 :number = this.form.value.winst2020 / this.form.value.balanstotaal2020
      let verhouding2021 :number = this.form.value.winst2021 / this.form.value.balanstotaal2021

      let verhouding : number = (verhouding2019 + verhouding2020 + verhouding2021)/3;
      let verhouding2022 :number = this.form.value.winst2022 / this.form.value.balanstotaal2022
      if(genoegWinst == true)
      {
        if (roundToDecimalPlaces((verhouding *1.25),2) <= verhouding2022 *1) {
          this.basicResult = 125;
        }
        if (roundToDecimalPlaces((verhouding *1.5),2) <= verhouding2022 *1 ) {
          this.basicResult = 250;
        }
        if (roundToDecimalPlaces((verhouding *2),2) <= verhouding2022*1 ) {
          this.basicResult = 375;
        }
      }
  
  
      }


    this.calculate = true;
  }
}
function roundToDecimalPlaces(num: number, decimalPlaces: number): number {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(num * factor) / factor;
}